import { createFileRoute } from '@tanstack/react-router';
import CustomerListPage from '@/pages/customer/customer-list-page';

export const Route = createFileRoute('/_protected/customers/')({
  component: CustomerListPage,
});
